import {
  computeSpaceFit,
  SPACE_FIT_VERDICT_OVER,
  SPACE_FIT_VERDICT_DENSE,
  SPACE_FIT_VERDICT_RIGHT,
  SPACE_FIT_VERDICT_UNDER,
} from "../../utils/spaceFitVerdict.js";

export const REGION_CAPACITY_BUCKETS = [
  { key: "over", label: "over", verdict: SPACE_FIT_VERDICT_OVER },
  { key: "near", label: "near", verdict: SPACE_FIT_VERDICT_DENSE },
  { key: "rightSized", label: "right-sized", verdict: SPACE_FIT_VERDICT_RIGHT },
  { key: "room", label: "room", verdict: SPACE_FIT_VERDICT_UNDER },
  { key: "noData", label: "no data", verdict: null },
];

const BUCKET_BY_VERDICT = new Map(
  REGION_CAPACITY_BUCKETS.filter((bucket) => bucket.verdict != null)
    .map((bucket) => [bucket.verdict, bucket.key]),
);

function emptyCounts() {
  return Object.fromEntries(REGION_CAPACITY_BUCKETS.map(({ key }) => [key, 0]));
}

/**
 * Count markets into Region view capacity buckets using the same canonical
 * per-market Space Fit verdict shown in Market view.
 */
export function getRegionCapacityBuckets(markets) {
  const byRegion = new Map();
  const total = emptyCounts();

  for (const market of markets ?? []) {
    const region = market.region ?? "No region";
    if (!byRegion.has(region)) byRegion.set(region, emptyCounts());

    const { verdict } = computeSpaceFit(
      market.totalDerivedSqft,
      market.totalSeats,
      market.totalPeople,
    );
    const key = BUCKET_BY_VERDICT.get(verdict) ?? "noData";
    byRegion.get(region)[key] += 1;
    total[key] += 1;
  }

  return { byRegion, total };
}
